import { FormattedMessage, FormattedDate } from 'react-intl';
import { Session } from '../../../helpers/types';
import clockImage from '../../../assets/image/clock-icon-25.png';
import calendarImage from '../../../assets/image/calendar-icon.png';
import { differenceInMinutes, getLangTimeFormat } from '../../../helpers/utils';
import DateFormatter from '../../Shared/DateFormatter';
import TimeFormatter from '../../Shared/TimeFormatter';

interface ClassCardBodyProps {
  isBooked: boolean;
  session: Session;
  lang: string;
  isSessionBooked: boolean;
}

function ClassCardBody({ isBooked, session, lang, isSessionBooked }: ClassCardBodyProps) {
  const is12hFormat = getLangTimeFormat(lang);

  const sessionDuration: number = 60;

  return (
    <section className="class-card-body-container" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="card-main">
        <div className="class-info-item flex justify-start align-center">
          {(differenceInMinutes(new Date(session?.date), Date.now()) <= 15 && isBooked) ||
          (differenceInMinutes(new Date(session?.date), Date.now()) <= 15 && isSessionBooked) ? (
            <div className="warning">
              <p>
                {lang !== 'zh' && (
                  <span>
                    <FormattedMessage id="classCard.your" />
                    &nbsp;
                  </span>
                )}
                {session && (
                  <span>
                    <FormattedDate
                      value={new Date(session?.date)}
                      hour={is12hFormat ? 'numeric' : '2-digit'}
                      minute={is12hFormat ? 'numeric' : '2-digit'}
                    />
                  </span>
                )}
                &nbsp;
                <FormattedMessage id="classCard.classIsReady" />
              </p>
            </div>
          ) : (
            <div>
              {isBooked ? (
                <div
                  className="class-info-item class-size flex justify-start align-center"
                  style={{ textTransform: 'capitalize' }}
                >
                  <img className="card-icon-img" src={calendarImage} alt="calendar-icon" />
                  <DateFormatter date={session?.date} />
                </div>
              ) : (
                <div>
                  <div
                    className="class-info-item class-size flex justify-start align-center"
                    style={{ paddingBottom: '0.8rem' }}
                  >
                    <img className="card-icon-img" src={calendarImage} alt="clock-icon" />
                    <DateFormatter date={session?.date} />
                  </div>
                  <div className="class-info-item class-size flex justify-start align-center">
                    <img className="card-icon-img" src={clockImage} alt="clock-icon" />
                    <TimeFormatter
                      date={session?.date}
                      is12hFormat={is12hFormat}
                      sessionDuration={sessionDuration}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className="class-info-item class-size flex justify-start align-center"
          style={{ paddingInlineStart: '1px' }}
        >
          {/* case 1: class is full */}
          {!isBooked && !isSessionBooked && session?.enrolledUsers === session.maxParticipants && (
            <div className="warning">This class is full</div>
          )}
          {/* case 2: yellow (warning) bold text if class is n-1/n full */}

          {/* case 3: booked */}
          {(isBooked || (!isBooked && isSessionBooked)) && (
            <>
              <img className="card-icon-img" src={clockImage} alt="clock-icon" />
              <TimeFormatter
                date={session?.date}
                is12hFormat={is12hFormat}
                sessionDuration={sessionDuration}
              />
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default ClassCardBody;
